var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.0013 6.33337c0-3.25467-2.7433-5.868004-6.044-5.654671-3.012.195334-5.28933 2.830671-5.28933 5.848671v4.29603c0 2.354 1.80067 4.41 4.15267 4.506 2.02466.0826 3.75396-1.226 4.31666-3.0474.2127-.6886.5527-1.3333 1.078-1.8266 1.0987-1.03203 1.786-2.49537 1.786-4.12203z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.33464 9.33341c-.36867 0-.66667-.29866-.66667-.66666v-2.13934c0-2.002 1.534-3.73066 3.41933-3.85266.928-.06134 1.84267.232 2.558.81266.286.232.3287.652.0973.938-.2326.286-.652.33-.93796.09667-.462-.37533-1.02-.55533-1.63-.51667-1.19867.07734-2.17334 1.20867-2.17334 2.522v2.13934c0 .368-.298.66666-.66666.66666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.2809 12.0001h-.28134c-.36866 0-.66666-.2987-.66666-.6667s.298-.6667.66666-.6667h.28134c.948 0 1.71866-.77062 1.71866-1.71862 0-.70734-.424-1.33334-1.08-1.59534l-1.76933-.708c-.342-.13666-.50867-.52466-.372-.86666s.52733-.508.86667-.37134l1.76933.708c1.16533.466 1.91867 1.578 1.91867 2.83334 0 1.68262-1.36934 3.05202-3.052 3.05202z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEar);
export default __webpack_public_path__ + "static/media/ear.d16904f25f738f8867e7578599106b8e.svg";
export { ForwardRef as ReactComponent };